import { RegionStore } from 'modules/region/region'
import { ValueOf } from 'types'

const enrichQueryKeyWithRegion = (key: string) => [key, RegionStore.region]

export const QueryKey = (() => ({
  get GetQueues() {
    return enrichQueryKeyWithRegion('GetQueues')
  },
  get GetUsers() {
    return enrichQueryKeyWithRegion('GetUsers')
  },
  get GetAgents() {
    return enrichQueryKeyWithRegion('GetAgents')
  },
  get GetSpecialisations() {
    return enrichQueryKeyWithRegion('GetSpecialisations')
  },
  get GetDepartments() {
    return enrichQueryKeyWithRegion('GetDepartments')
  },
  get GetAreas() {
    return enrichQueryKeyWithRegion('GetAreas')
  },
  get GetChannels() {
    return enrichQueryKeyWithRegion('GetChannels')
  },
  get GetTicketsVolume() {
    return enrichQueryKeyWithRegion('GetTicketsVolume')
  },
  get GetTicketsVolumeAddition() {
    return enrichQueryKeyWithRegion('GetTicketsVolumeAddition')
  },
  get GetAgentAttendanceDetails() {
    return enrichQueryKeyWithRegion('GetAgentAttendanceDetails')
  },
  get GetAgentAttendanceIntervals() {
    return enrichQueryKeyWithRegion('GetAgentAttendanceIntervals')
  },
  get GetAgentAttendanceTimeline() {
    return enrichQueryKeyWithRegion('GetAgentAttendanceTimeline')
  },
  get GetQueuesHealthDetails() {
    return enrichQueryKeyWithRegion('GetQueuesHealthDetails')
  },
  get GetTickets() {
    return enrichQueryKeyWithRegion('GetTickets')
  },
  get GetAssignedTickets() {
    return enrichQueryKeyWithRegion('GetAssignedTickets')
  },
  get GetQueueStatsFilter() {
    return enrichQueryKeyWithRegion('GetQueueStatsFilter')
  },
  get GetAlertingPolicies() {
    return enrichQueryKeyWithRegion('GetAlertingPolicies')
  },
  get GetAlertingSlackUserGroups() {
    return enrichQueryKeyWithRegion('GetAlertingSlackUserGroups')
  },
  get GetAlertingMetrics() {
    return enrichQueryKeyWithRegion('GetAlertingMetrics')
  },
  get GetAlertingIncidentsTimelines() {
    return enrichQueryKeyWithRegion('GetAlertingIncidentsTimelines')
  },
  get GetAlertingActions() {
    return enrichQueryKeyWithRegion('GetAlertingActions')
  },
  get RefreshAlertingSlackUserGroups() {
    return enrichQueryKeyWithRegion('RefreshAlertingSlackUserGroups')
  },
}))()

export type QueryKey = ValueOf<typeof QueryKey>
